<template lang="pug">
.twitch__wrap
  h1.twitch__title(v-html="$t('twitch.title')")

  .twitch__login
    .twitch__login-text {{ $t("twitch.done.login_site") }}
    .twitch__login-nickname {{ user.login }}
  .twitch__login
    .twitch__login-text {{ $t("twitch.done.login_twitch") }}
    .twitch__login-nickname {{ twitchUser.result.display_name }}

  p.twitch__text {{ $t("twitch.done.watch_text") }}

  a.button.button--corner.button--red.twitch__button(:href="getTwitchLink")
    i.icon.icon-social-twitch
    span {{ $t("twitch.done.watch_button") }}

  p.twitch__note {{ $t("twitch.done.note") }}

</template>
<script>
import { mapState } from "vuex";

export default {
  name: "TwitchSuccess",

  props: {
    twitchUser: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  computed: {
    ...mapState("global", ["user"]),

    getTwitchLink() {
      return "https://www.twitch.tv/directory/game/Conqueror%27s%20Blade";
    },
  },
};
</script>
